import PreloaderText from '../Preloaders/PreloaderText';

export default function RecomendationDescriptionPreloader() {
    return <div className="RecomendationDescription">
        <div style={{
            marginBottom: '2rem',
            paddingTop: '1.5rem',
        }}>
            <PreloaderText />
        </div>
    </div>
}
